/*global google*/
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

import { CurrencyFormat } from '../../utils';

import Breadcrumbs from '../components/Breadcrumbs';
import ModalDealershipDetails from '../components/ModalDealershipDetails';
import ModalConfigurationDetail from '../components/Modals/ModalConfigurationDetail';

import useConfiguratorData from '../hooks/useConfiguratorData';
import useDealershipsData from '../hooks/useDealershipsData';
import usePriceData from '../hooks/usePriceData';




const initialMapState = {
    isLoading: false,
    centerAt: { coords: { lat: -33.4488897, lng: -70.6692655 } },
    selectedMarker: null,
    userLocation: null,
    showResults: false,
    mapConfig: {
        zoom: 12
    },
}


const MapComponent = withScriptjs(withGoogleMap(({ selectedMarker, zoom, centerAt, markers, onItemClick, userLocation }) => {

    const styledMap = [{ "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }]

    const selectedIcon = {
        url: `${window._env_.STATIC_HOST}/static/website/images/map/selected-marker.svg`,
        size: new google.maps.Size(36, 63),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(18, 48),
    };

    const defaultIcon = {
        url: `${window._env_.STATIC_HOST}/static/website/images/map/default-marker.svg`,
        size: new google.maps.Size(12, 12),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(6, 6),
    };

    return (
        <GoogleMap
            defaultZoom={12}
            defaultCenter={selectedMarker}
            center={centerAt.coords}
            zoom={zoom}
            options={{
                mapTypeControl: false,
                streetViewControl: false,
                minZoom: 4,
                maxZoom: 18,
                styles: styledMap,
                zoomControl: false,
                fullscreenControl: false
            }}
        >
            {markers && markers.map((marker) => {
                if (selectedMarker && selectedMarker.id === marker.id) return;
                return <Marker
                    key={`${marker.id}`}
                    position={{ lat: Number(marker.coords.lat), lng: Number(marker.coords.lng) }}
                    icon={defaultIcon}
                    onClick={(e) => onItemClick(e, marker)}
                />
            })}
            {selectedMarker &&
                <Marker
                    key={`${selectedMarker.id}`}
                    position={selectedMarker.coords}
                    icon={selectedIcon}
                />
            }
            {userLocation &&
                <Marker
                    key={`userLocation`}
                    position={userLocation.coords}
                    zIndex={0}
                />
            }

        </GoogleMap>
    )
}));

const Dealerships = (props) => {

    const history = useHistory();
    const { getSelectedVersion, getSelectedModel } = useConfiguratorData();
    const { getFinalPrice } = usePriceData();
    const { dealerships, getDealerships } = useDealershipsData();
    const [mapState, setMapState] = useState(initialMapState);
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');

    const selectedModel = getSelectedModel();
    const selectedVersion = getSelectedVersion();
    const finalPrice = getFinalPrice();

    const [toggleSearchBox, setToggleSearchBox] = useState(false);

    const containerRefFilter = useRef(null);
    const openRefFilter = useRef(null);

    const containerRefSearchBox = useRef(null);
    const openRefSearchBox = useRef(null);

    if (!selectedVersion) {
        history.replace('/');
        return null;
    }

    const handleClickOutside = (event, ref, containerRef, callback) => {
        if (ref.current && ref.current.contains(event.target)) {
            callback(true);
        }
        else if (containerRef.current && !containerRef.current.contains(event.target)) {
            callback(false);
        }
    }

    useEffect(() => {
        // Bind the event listener
        document.addEventListener("mousedown", (e) => handleClickOutside(e, openRefSearchBox, containerRefSearchBox, setToggleSearchBox));
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", (e) => handleClickOutside(e, openRefSearchBox, containerRefSearchBox, setToggleSearchBox));
        };
    }, [toggleSearchBox]);


    const onItemClick = (e, item) => {
        item.coords = { lat: Number(item.coords.lat), lng: Number(item.coords.lng) };
        setMapState(prevState => ({
            ...prevState,
            selectedMarker: item,
            centerAt: item,
            mapConfig: {
                zoom: 16
            }
        }));

        setToggleSearchBox(false);
    };

    const clearSelectedMarker = () => {
        setMapState(initialMapState);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getDealerships();
    }, []);

    const visibleDealerships = dealerships.filter(dealer => {
        let searchMatch;

        if (search.length >= 3) {
            if (dealer.name.toLowerCase().indexOf(search.toLowerCase()) >= 0 || dealer.address.toLowerCase().indexOf(search.toLowerCase()) >= 0) {
                searchMatch = true;
            } else {
                searchMatch = false;
            }
        } else {
            searchMatch = true;
        }

        return searchMatch;
    });

    return (
        <div className="dealership-selector">
            <Breadcrumbs dealers />
            <div className="full-viewport-width">
                <div className="main-container">
                    <div className="model-price-detail">
                        <div className="modelname-and-price">
                            {selectedModel.name} {selectedVersion.name} | <span className="price">{CurrencyFormat(finalPrice)}</span>
                        </div>
                        <div className="detail">
                            <a className="btn" onClick={() => setIsOpen(true)}>Ver detalle <i className="icon arrow-right"></i></a>
                        </div>
                    </div>
                    <div className="map-header">
                        <div className="title">
                            <h1>Elige tu Concecionaria y contáctanos</h1>
                            <h4>Para ayudarte a tomar la mejor desición con tu compra, elige una concesionaria y envíanos tu cotización</h4>
                        </div>
                        <div className="search-box">
                            <input type="text" name="search" className="input-search" placeholder="Buscar un concesionario" ref={openRefSearchBox} onClick={() => setToggleSearchBox(true)} onChange={(e) => setSearch(e.target.value)}></input>
                            {toggleSearchBox &&
                                <ul ref={containerRefSearchBox}>
                                    {visibleDealerships && visibleDealerships.map(dealer => (
                                        <li key={`searched-dealer-${dealer.id}`} onClick={(e) => onItemClick(e, dealer)}>
                                            <b>{dealer.name}</b>
                                            <span>{dealer.address.split(',')[0]}</span>
                                        </li>
                                    ))}
                                    {!visibleDealerships.length ?
                                        <li>
                                            <p>No se encontraron resultados</p>
                                        </li>
                                        : null}
                                </ul>
                            }
                        </div>
                    </div>
                    <div className="map-container">
                        <MapComponent
                            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAPS_V3_APIKEY}&v=3.exp&libraries=geometry,drawing,places`}
                            loadingElement={<div className="map-inside" />}
                            containerElement={<div className="map-inside" />}
                            mapElement={<div className="map-inside" />}
                            selectedMarker={mapState.selectedMarker}
                            userLocation={mapState.userLocation}
                            zoom={mapState.mapConfig.zoom}
                            centerAt={mapState.centerAt}
                            markers={dealerships}
                            onItemClick={onItemClick}
                        />
                        {mapState.selectedMarker ? (
                            <div className="main-container dealership-modal-container">
                                <ModalDealershipDetails selectedMarker={mapState.selectedMarker} clearSelectedMarker={clearSelectedMarker} />
                            </div>
                        ) : null}

                    </div>
                </div>
            </div>
            <ModalConfigurationDetail isOpen={isOpen} onCloseModal={() => setIsOpen(false)} />
        </div>
    );

}

export default Dealerships;